import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api, { setAuthToken } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const stored = localStorage.getItem('sdr_token');
    if (!stored) { setUser(false); setLoading(false); return; }
    setAuthToken(stored);
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
    } catch {
      localStorage.removeItem('sdr_token');
      setAuthToken(null);
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    if (data.access_token) {
      localStorage.setItem('sdr_token', data.access_token);
      setAuthToken(data.access_token);
    }
    if (data.refresh_token) {
      localStorage.setItem('sdr_refresh_token', data.refresh_token);
    }
    setUser(data);
    return data;
  };

  const register = async (email, password, name, organisation, account_type = 'business_owner') => {
    const { data } = await api.post('/auth/register', { email, password, name, organisation, account_type });
    if (data.access_token) {
      localStorage.setItem('sdr_token', data.access_token);
      setAuthToken(data.access_token);
    }
    if (data.refresh_token) {
      localStorage.setItem('sdr_refresh_token', data.refresh_token);
    }
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    localStorage.removeItem('sdr_token');
    localStorage.removeItem('sdr_refresh_token');
    setAuthToken(null);
    setUser(false);
    window.location.replace('/login');
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
